import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const RadioChecked = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" sx={{ borderRadius: '50%' }} {...props}>
            <circle cx="10" cy="10" r="9.5" fill="currentColor" stroke="currentColor" />
            <circle cx="10" cy="10" r="4" fill="white" />
        </SvgIcon>
    );
};

export default RadioChecked;
